import type { IOorkV1DiagnosticReportCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1DiagnosticReportCustomControlData';
import type { ICustomControlProcedureDiagnosticReportReadProps } from '@frontend/components/pages/customControls/interfaces';
import { getServiceLabel } from '@common/customControls/getServiceLabel';
import { GradingSummary } from '@common/enums';
import { getDisplayName } from '@common/utils/getDisplayName';
import { booleanAsJaNee } from '@common/utils/textUtils';
import { ProcessContainer } from '@frontend/components/pages/episodes/common';
import { ProcessItemHeader } from '@frontend/components/pages/episodes/ProcessItemHeader';
import { translateKey } from '@frontend/translate';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { FormGroupRead } from '../../utils/v1/FormGroupRead';
import { DiagnosticReportAfwijkingenRead } from './components/DiagnosticReportAfwijkingenRead';

export function OorkV1DiagnosticReportRead(props: ICustomControlProcedureDiagnosticReportReadProps) {
    const customControlData: IOorkV1DiagnosticReportCustomControlData = props.diagnosticReport.customControlData;

    return (
        <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
            <ProcessItemHeader
                date={props.diagnosticReport.dateSent}
                isFirstItem={props.isFirstItem}
                isItemOpen={props.reportItemState.isOpen}
                onToggle={async (isOpened) =>
                    await props.updateReportItemState({ ...props.reportItemState, isOpen: isOpened })
                }
                organizationName={props.diagnosticReport.performerOrganization?.name}
                practitionerName={
                    props.diagnosticReport.performerPractitioner
                        ? getDisplayName(props.diagnosticReport.performerPractitioner)
                        : undefined
                }
                process={props.process}
                status={
                    props.diagnosticReport.gradingSummary === GradingSummary.deviant
                        ? translateKey('diagnosis.deviant')
                        : undefined
                }
                title={getServiceLabel(
                    props.process.code,
                    'diagnosticReport',
                    translateKey('diagnosticReport.findings')
                )}
            />

            <CustomControlCollapseBody isOpen={props.reportItemState.isOpen}>
                <DiagnosticReportAfwijkingenRead customControlData={customControlData} />

                <FormGroupRead
                    label="Relevante comorbiditeit in relatie tot de rijgeschiktheid"
                    value={booleanAsJaNee(customControlData.relevante_comorbiditeit)}
                />
                {customControlData.relevante_comorbiditeit && (
                    <FormGroupRead
                        label="Toelichting relevante comorbiditeit"
                        value={customControlData.toelichting_relevante_comorbiditeit}
                    />
                )}

                <FormGroupRead
                    label="Aanvullende informatie"
                    value={customControlData.aanvullende_informatie}
                />
            </CustomControlCollapseBody>
        </ProcessContainer>
    );
}
